import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'ai', 'Ai', [["path",{"d":"M8 16v-6a2 2 0 1 1 4 0v6"}],["path",{"d":"M8 13h4"}],["path",{"d":"M16 8v8"}]]);